const FONT_WEIGHTS = {
  lighter: 300,
  light: 400,
  regular: 500,
  medium: 600,
  bold: 700
};

const typography = {
  fontFamily: ['Inter', 'sans-serif'].join(','),
  fontWeightLight: FONT_WEIGHTS.light,
  fontWeightRegular: FONT_WEIGHTS.regular,
  fontWeightMedium: FONT_WEIGHTS.medium,
  fontWeightBold: FONT_WEIGHTS.bold,
  //
  h1: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '64px',
    lineHeight: '80px'
  },
  h2: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '48px',
    lineHeight: '64px'
  },
  h3: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '32px',
    lineHeight: '48px'
  },
  h4: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '24px',
    lineHeight: '36px'
  },
  h5: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '20px',
    lineHeight: '30px'
  },
  h6: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '18px',
    lineHeight: '28px'
  },
  //
  subtitle1: {
    fontWeight: FONT_WEIGHTS.medium,
    fontSize: '16px',
    lineHeight: '24px'
  },
  subtitle2: {
    fontWeight: FONT_WEIGHTS.medium,
    fontSize: '14px',
    lineHeight: '22px'
  },
  body1: {
    fontWeight: FONT_WEIGHTS.light,
    fontSize: '16px'
    // lineHeight: '24px'
  },
  body2: {
    fontWeight: FONT_WEIGHTS.light,
    fontSize: '14px',
    lineHeight: '22px'
  },
  body3: {
    fontWeight: FONT_WEIGHTS.regular,
    fontSize: '14px',
    lineHeight: '22px'
  },
  body4: {
    fontWeight: FONT_WEIGHTS.regular,
    fontSize: '13px',
    lineHeight: '22px'
  },
  caption: {
    fontWeight: FONT_WEIGHTS.light,
    fontSize: '12px',
    lineHeight: '18px'
  },
  overline: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '12px',
    lineHeight: '18px',
    textTransform: 'uppercase'
  },
  //
  buttonLg: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '15px',
    lineHeight: '26px',
    textTransform: 'none'
  },
  buttonMd: {
    fontWeight: FONT_WEIGHTS.medium,
    fontSize: '14px',
    lineHeight: '24px',
    textTransform: 'none'
  },
  buttonSm: {
    fontWeight: FONT_WEIGHTS.bold,
    fontSize: '12px',
    lineHeight: '22px',
    textTransform: 'none'
  }
} as const;

export default typography;
